export default "__VITE_ASSET__CNS1Zvij__"